import React from 'react';
export function Dashboard() {
  return <div className="p-6 h-full" data-id="element-103">
      <header className="mb-8" data-id="element-104">
        <h1 className="text-3xl font-bold text-[#e20019]" data-id="element-105">Dashboard</h1>
        <p className="text-gray-600" data-id="element-106">
          Willkommen im Kleinemas Produktionssystem
        </p>
      </header>
      <div className="flex items-center justify-center h-[calc(100%-8rem)]" data-id="element-107">
        <div className="text-center" data-id="element-108">
          <p className="text-xl text-gray-600 mb-2" data-id="element-109">
            Das Dashboard wird zu einem späteren Zeitpunkt entwickelt.
          </p>
          <p className="text-gray-500" data-id="element-110">
            Bitte nutzen Sie die Navigation, um auf andere Bereiche zuzugreifen.
          </p>
        </div>
      </div>
    </div>;
}